import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Btn } from "@/components/common";
import { RefreshCw } from "lucide-react";

const Change = ({ c, label }) =>
  c ? <span className="whitespace-nowrap">{label} <s className="text-slate-400">{c.old}</s> → <b className="text-sky-700">{c.new}</b></span> : null;

export default function SpeedboatAlign() {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);
  const preview = async () => {
    setBusy(true);
    try { setRows((await api.get("/speedboat-schedule/align")).data.rows); } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  const apply = async () => {
    setBusy(true);
    try {
      const r = await api.post("/speedboat-schedule/align");
      toast.success(`${r.data.updated} prenotazioni allineate`);
      setRows(null);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-4 rounded-md border border-amber-200 bg-amber-50/50 p-3" data-testid="sb-align">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-semibold text-slate-800">Allinea prenotazioni</span>
        <span className="text-[11px] text-slate-500">arrivi e partenze da oggi in poi (confermate e opzionate) con un orario che non esiste più → barca più vicina di quel giorno. Salva prima gli orari.</span>
        <Btn data-testid="sb-align-preview" variant="secondary" onClick={preview} disabled={busy} className="ml-auto"><RefreshCw size={14} /> Controlla</Btn>
      </div>
      {rows && (rows.length === 0 ? (
        <div className="text-sm text-emerald-700 mt-2" data-testid="sb-align-none">Tutte le prenotazioni sono già allineate.</div>
      ) : (
        <div className="mt-2">
          <div className="max-h-72 overflow-auto rounded border border-amber-100 bg-white">
            <table className="w-full text-xs">
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-b border-slate-100" data-testid={`sb-align-row-${r.id}`}>
                    <td className="px-2 py-1.5 font-medium text-slate-800">{r.guest || "—"}</td>
                    <td className="px-2 py-1.5 text-slate-500 whitespace-nowrap">{r.checkin} → {r.checkout}</td>
                    <td className="px-2 py-1.5 text-slate-500">{r.room} · {r.status}</td>
                    <td className="px-2 py-1.5 space-x-3"><Change c={r.changes.checkin_time} label="arrivo" /><Change c={r.changes.checkout_time} label="partenza" /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-end gap-2 mt-2">
            <Btn data-testid="sb-align-cancel" variant="secondary" onClick={() => setRows(null)} disabled={busy}>Annulla</Btn>
            <Btn data-testid="sb-align-apply" onClick={apply} disabled={busy}>Applica a {rows.length} prenotazioni</Btn>
          </div>
        </div>
      ))}
    </div>
  );
}
